export default __webpack_public_path__ + "static/media/70.16445be1.jpg";